import { useDispatch } from 'react-redux';

import { openManageCookies } from '../../actions';

const ManageCookiesButton = ({
  label,
  'label-hidden': labelHidden,
  className,
}) => {
  const dispatch = useDispatch();

  return (
    <button
      className={className}
      type="button"
      aria-label={label}
      title={labelHidden ? label : null}
      onClick={() => {
        dispatch(openManageCookies());
      }}
    >
      <span className="fas fa-cookie-bite" aria-hidden="true" />
      {labelHidden ? null : <span className="pl-base">{label}</span>}
    </button>
  );
};

export default ManageCookiesButton;
